import React, { useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { useOktaAuth } from '@okta/okta-react';
import { setOktaAuth } from '../api/client';
import router from '../router';

const App: React.FC = () => {
  const oktaAuthContext = useOktaAuth();
  const oktaAuth = oktaAuthContext?.oktaAuth;

  // Pass OktaAuth instance to API client so it can access tokens
  useEffect(() => {
    if (oktaAuth) {
      console.log('🔧 Setting oktaAuth instance in API client');
      setOktaAuth(oktaAuth);
    }
  }, [oktaAuth]);

  // Router handles everything now: auth, tenant selection, and routing
  // AuthGuard in router will check authentication first
  // Then AppShell will handle tenant selection if needed
  return <RouterProvider router={router} />;
};

export default App;
